// Module
var code = "<div class=\"ToolBarPreview\"> <label> <i class=\"icon-lock\" aria-hidden=\"true\"></i> <span class=\"labelText\"><!-- ko text: Label --><!-- /ko --></span> </label> </div>";
// Exports
export default code;